// Lightweight runtime detection of the deployment environment.
// We check the hostname so we don't have to thread an env var into the
// client bundle.

export type DeployEnv = "production" | "staging" | "local";

export function deployEnv(): DeployEnv {
  if (typeof window === "undefined") return "local";
  const host = window.location.hostname;
  if (host.includes("staging")) return "staging";
  if (host.endsWith("fly.dev") || host.endsWith("tapvocab.app")) return "production";
  return "local";
}

export function isStaging(): boolean {
  return deployEnv() === "staging";
}
